import React from 'react';
import styled, { keyframes } from 'styled-components';

const float1 = keyframes`
  0% { transform: translate(0, 0); }
  50% { transform: translate(60px, 36px); }
  100% { transform: translate(0, 0); }
`;

const float2 = keyframes`
  0% { transform: translate(0, 0); }
  50% { transform: translate(-60px, -36px); }
  100% { transform: translate(0, 0); }
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
`;

const Layer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const Spotlight1 = styled.div`
  position: absolute;
  top: 80px;
  left: 80px;
  width: 384px;
  height: 384px;
  background: radial-gradient(circle, ${(props) => props.color} 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0.2;
  filter: blur(64px);
  animation: ${float1} 8s ease-in-out infinite;
`;

const Spotlight2 = styled.div`
  position: absolute;
  bottom: 80px;
  right: 80px;
  width: 384px;
  height: 384px;
  background: radial-gradient(circle, ${(props) => props.color} 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0.2;
  filter: blur(64px);
  animation: ${float2} 10s ease-in-out infinite;
`;

const StaticSpotlight1 = styled.div`
  position: absolute;
  top: 0;
  left: 25%;
  width: 384px;
  height: 384px;
  background: #2eb9a7;
  border-radius: 50%;
  opacity: 0.05;
  filter: blur(64px);
`;

const StaticSpotlight2 = styled.div`
  position: absolute;
  bottom: 25%;
  right: 25%;
  width: 384px;
  height: 384px;
  background: #ed60a7;
  border-radius: 50%;
  opacity: 0.06;
  filter: blur(64px);
`;

export const GridBackground = ({ variant = 'default' }) => {
  const isSignup = variant === 'signup';

  return (
    <Container>
      {/* Main grid pattern */}
      <Layer
        style={{
          backgroundImage: `
            linear-gradient(rgba(46, 185, 167, 0.06) 1px, transparent 1px),
            linear-gradient(90deg, rgba(46, 185, 167, 0.06) 1px, transparent 1px)
          `,
          backgroundSize: '80px 80px',
        }}
      />

      {/* Radial gradient overlays for varying opacity */}
      <Layer
        style={{
          background: `
            radial-gradient(circle at 20% 30%, rgba(46, 185, 167, 0.12) 0%, transparent 40%),
            radial-gradient(circle at 80% 70%, rgba(255, 181, 37, 0.10) 0%, transparent 40%),
            radial-gradient(circle at 50% 50%, transparent 20%, rgba(4, 12, 46, 0.7) 70%)
          `,
        }}
      />

      {/* Secondary finer grid for detail */}
      <Layer
        style={{
          opacity: 0.4,
          backgroundImage: `
            linear-gradient(rgba(46, 185, 167, 0.08) 1px, transparent 1px),
            linear-gradient(90deg, rgba(46, 185, 167, 0.08) 1px, transparent 1px)
          `,
          backgroundSize: '20px 20px',
        }}
      />

      {/* Static spotlight effects */}
      {isSignup && (
        <>
          <StaticSpotlight1 />
          <StaticSpotlight2 />
        </>
      )}

      {/* Animated spotlight effects */}
      <Spotlight1 color={isSignup ? '#22d3ee' : '#3599e7'} />
      <Spotlight2 color={isSignup ? '#ed60a7' : '#2eb9a7'} />
    </Container>
  );
};
